import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { InventoryList } from 'components/models/inventories/InventoryList'
import { Loading } from 'components/shared/Loading'
import { useArtistsByOwnerId } from 'hooks/artists/useArtistsByOwnerId'
import { useInventories } from 'hooks/inventories'
import { isEmpty } from 'lodash'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { extractAvailableOnly, filterInventoryParams } from 'utils/inventoryFilterParams'

type Props = {
  owner: Owner
}

export const ArtworkListTab: FC<Props> = ({ owner }) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()
  const router = useRouter()

  const ART_WORK_LIMIT = 18

  const { inventories, totalCount, error, isValidating, setSize } =
    useInventories({
      ownerId: owner.id,
      limit: ART_WORK_LIMIT,
      searchParams: filterInventoryParams(router.query),
      availableOnly: extractAvailableOnly(router.query),
    })

  const { data: artists = [] } = useArtistsByOwnerId(owner.id)

  const isDisplayEmptyStatus = isEmpty(error) && isEmpty(inventories)

  if (isValidating && inventories.length === 0) {
    return (
      <div style={{ paddingTop: xs ? 32 : 60 }}>
        <Loading />
      </div>
    )
  }

  if (isDisplayEmptyStatus) {
    return (
      <div
        style={{
          paddingTop: 100,
          paddingBottom: 100,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 24,
          justifyContent: 'center',
        }}
      >
        <Image src="/no-objects/artwork.png" width={130} height={130} />
        <Typography.Text style={{ fontSize: 16, lineHeight: 1 }}>
          {t('公開作品はありません')}
        </Typography.Text>
      </div>
    )
  }

  if (error) {
    return <></>
  }

  return (
    <div style={{ padding: xs ? '32px 16px 0px 16px' : '60px 64px 0px' }}>
      <InventoryList
        inventories={inventories}
        isValidating={isValidating}
        setSizeInventories={setSize}
        totalCount={totalCount}
        xs={xs}
        artists={artists}
        pathname={`/owners/${owner.id}`}
      />
    </div>
  )
}
